import airtableProvider from "../../providers/prod/airtable";
import {
	AddOn,
	AddOnPermissionType,
	AddOnPlan,
	AddOnStatus,
	AddOnType,
	Asset,
	BillingCycle,
	Currency,
	HighlightFeature,
	Price,
	UsageStats,
	UsageStatsType,
} from "../../../../index";

const a004AddOn = new AddOn({
	internalId: "a004",
	externalId: "pro_01hsavtv2t7cprq8kmx6rv4er0",
	shortName: "Airtable upload attachments",
	longName: "Airtable upload attachments",
	shortDescription: "Bulk upload attachments to Airtable",
	longDescription:
		"* Upload attachments in bulk.\n* Use advanced features, such as grouping the attachments.\n* Using this extension uploads the files through our remote servers, there is a limit of 10GB per month.\n* This extension works with any file type and for multiple attachments in a single cell.",
	type: AddOnType.APP_EXTENSION,
	iconAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/a004/icons/a004_icon_rounded.png"
	),
	coverAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/a004/assets/background4.png"
	),
	previewAssets: [
		Asset.image(
			"https://storage.googleapis.com/cdn.version2.io/add-ons/a004/screenshots/a004_screenshot_1.png"
		),
	],
	docsUrl:
		"https://docs.version2.io/articles/airtable-upload-attachments-bae920-1c797",
	providersIds: [airtableProvider._.id],
	status: AddOnStatus.ACTIVE,
	plans: [
		new AddOnPlan({
			billingCycle: BillingCycle.yearly(),
			internalId: "a004_p001",
			externalId: "pri_01hsawydba2y9d6wb39e6h9kdx",
			prices: [new Price({ currency: Currency.USD, amount: 14 })],
		}),
		new AddOnPlan({
			billingCycle: BillingCycle.monthly(),
			internalId: "a004_p002",
			externalId: "pri_01hsawz1n7ghbdt1d2kedqsm3s",
			prices: [new Price({ currency: Currency.USD, amount: 2 })],
		}),
	],
	usageStats: [
		new UsageStats({
			id: "remote_bytes",
			name: "Remote bytes",
			description: "The total number of bytes uploaded to the remote server.",
			type: UsageStatsType.BYTES,
			max: 1073741824,
		}),
		new UsageStats({
			id: "remote_files",
			name: "Remote files",
			description: "The total number of files uploaded to the remote server.",
			type: UsageStatsType.FILES,
		}),
	],
	settingsConfig: [],
	highlightFeatures: [
		new HighlightFeature({
			title: "Any file type",
			description:
				"Works with any file type and for multiple attachments in a single cell.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/file-text.svg",
		}),
		new HighlightFeature({
			title: "Live preview",
			description: "Preview the files files before uploading them.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/eye.svg",
		}),
		new HighlightFeature({
			title: "Advanced filters",
			description:
				"Use advanced filters to group attachments by folder and more.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/filter.svg",
		}),
	],
	allowedPermissionTypes: [
    AddOnPermissionType.AIRTABLE_ACCOUNT,
		AddOnPermissionType.AIRTABLE_ACCOUNT_INVITE,
    AddOnPermissionType.AIRTABLE_BASE,
		AddOnPermissionType.AIRTABLE_SHARED,
	],
});

export default a004AddOn;
